import React from 'react';
import { AdminSidenav, AdminHeader, AdminFooter } from '../components';
import './AdminLayout.css';

interface AdminLayoutProps {
  children: React.ReactNode;
}

export const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  return (
    <div className="admin-layout">
      <AdminSidenav />
      <AdminHeader />
      <main className="admin-layout__main">
        {children}
      </main>
      <AdminFooter />
    </div>
  );
};
